/**
 * Skip To Content Component
 *
 * Accessibility feature that allows keyboard users to skip
 * navigation and go directly to main content.
 */

import React from "react";
import * as styles from "./SkipToContent.module.scss";

const SkipToContent = () => {
  return (
    <a href="#main" className={styles.skipLink}>
      Skip to main content
    </a>
  );
};

export default SkipToContent;
